import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/lane-workspace");

export const Route = createFileRoute("/lane-workspace/")({
  head: () => ({
    meta: [
      { title: "Lane workspace — LevelLoad" },
      {
        name: "description",
        content: "Search a lane by site, mode or carrier and open its workspace in LevelLoad.",
      },
      { property: "og:title", content: "Lane workspace — LevelLoad" },
      {
        property: "og:description",
        content: "Search a lane by site, mode or carrier and open its workspace in LevelLoad.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
